<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex">
                <h1>User Approval</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/admin">Admin</a></li>
                    <li class="active"><a routerLink="/admin/userApproval">User Approval</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div id="accordion" class="mb-1">
        <div class="card">
            <div class="card-header pointer" id="memberheading">
                <h3 data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
                    aria-controls="collapseFilter">
                    <i class="fa fa-angle-down pull-right customIcon mr-2"></i>Advanced Search
                </h3>
            </div>
            <div id="collapseFilter" class="collapse show" aria-labelledby="memberheading" data-parent="#accordion">
                <div class="card card-body">
                    <form [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Entity Type</label>
                                <select class="form-control form-control-sm selectpicker" title="Select Entity Type"
                                    formControlName="entity">
                                    <option *ngFor="let data of entityList" value="{{data.key}}">
                                        {{data.key+" - "+data.value}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Status</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="regStatus"
                                    title="Select Status">
                                    <option *ngFor="let data of statusArray" value="{{data.code}}">{{data.value}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Submission Date</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm datepicker date"
                                        #dp="bsDaterangepicker" bsDaterangepicker [(bsValue)]="bsValue"
                                        [bsConfig]="{rangeInputFormat:'DD-MMM-YYYY', displayMonths:1}"
                                        formControlName="createdDate" placeholder="Select Submission Date Range">
                                    <div class="input-group-append datepicker cursor">
                                        <span class="input-group-text">
                                            <i class="fa fa-calendar pointer" [(bsValue)]="bsValue" bsDaterangepicker
                                                [bsConfig]="{ rangeInputFormat:'DD-MMM-YYYY', displayMonths:1}"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                                <button class="btn btn-primary btn-sm full-width" (click)="onSubmit()">Search</button>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                                <button class="btn btn-secondary btn-sm full-width" (click)="reset()">Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-body" *ngIf="showDataTable">
        <div class="row clearSearch">
            <button type="button" class="btn btn-cancel btn-sm" (click)="clearSearch()" aria-label="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-x"
                    viewBox="0 0 15 15">
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Filter</button>
        </div>
        <div class="col-lg-6">
            <div class="row newReload">
                <div class="pl-4 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-arrow-repeat pointer reload" viewBox="0 0 16 16" (click)="onSubmit()">
                        <title>Reload</title>
                        <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                        <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table id="adminMisReport" class="table common-table" datatable [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Registration ID</th>
                        <th>Participant Name</th>
                        <th>Login Name</th>
                        <th>Entity Type</th>
                        <th>Member Code</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Last Modified Date</th>
                        <th>Checked By</th>
                        <th>Approval / Rejection Date</th>
                    </tr>
                    <tr class="column-search">
                        <th></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of responseData; let i=index">
                        <td>{{i+1}}</td>
                        <td class="pointer"><a (click)="open(data.regID)">{{data.regID}}</a></td>
                        <td class="pointer "><a (click)="open(data.regID)">{{data.pname}}</a></td>
                        <td class="nocase">{{data.loginName}}</td>
                        <td>{{getEntityValue(data.entityType)}}</td>
                        <td>{{data.memCode || '-'}}</td>
                        <td>{{getStatus(data.status)}}</td>
                        <td>{{data.createdDTM | date : 'dd-MM-yyyy HH:mm'}}</td>
                        <td>{{data.modifiedDTM | date : 'dd-MM-yyyy HH:mm'}}</td>
                        <td class="nocase">{{data.checkerID}}</td>
                        <td>{{data.checkerDTM | date : 'dd-MM-yyyy HH:mm'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>